module.exports = __webpack_public_path__ + "static/undraw_message_sent_1030-f077410471c4c73eeaf9a7e1e559aac8.svg";